import { ModalWrapper } from "@/components/atoms/ModalWrapper";
import { CreateGroupForm } from "@/components/molecules/CreateGroupForm";
import { useCreateGroupModal } from "@/hooks/useCreateGroupModal";

interface CreateGroupModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSuccess?: (groupId: string) => void;
}

export const CreateGroupModal = ({
  isOpen,
  onClose,
  onSuccess,
}: CreateGroupModalProps) => {
  const { handleCreateGroup, isPending } = useCreateGroupModal({
    onClose,
    onSuccess,
  });

  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title="Create New Group"
      className="w-[65vw] h-[90vh] [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-transparent [&::-webkit-scrollbar-thumb]:bg-white [&::-webkit-scrollbar-thumb]:rounded-full"
    >
      <CreateGroupForm
        onSubmit={handleCreateGroup}
        onCancel={onClose}
        isLoading={isPending}
      />
    </ModalWrapper>
  );
};
